import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { createColumnHelper } from "@tanstack/react-table";
import { renderValue } from "utils/renderCompanyCell";
import StatusPillButtons from "components/Buttons/StatusPillButtons";

const Columns = () => {
  const columnHelper = createColumnHelper();

  return [
    columnHelper.accessor("agency_name", {
      header: "Agency Name",
      size: 448,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("leads_opted_status", {
      header: "Opted Leads Status",
      size: 200,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => {
        const value = info.getValue();
        return <StatusPillButtons status={value} dot={false} />;
      }
    }),
    columnHelper.accessor("roster_updated_at", {
      header: "Roster Updated At",
      size: 200,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("total_team_members", {
      header: "Total Team Members",
      size: 200,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("total_creators", {
      header: "Total Creators",
      size: 200,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("actions", {
      header: "Actions",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell table-link",
      enableSorting: false,

      // cell is a React component — safe to use hooks here
      cell: (info) => {
        const row = info.row.original;
        const navigate = useNavigate();
        const location = useLocation();

        const handleViewAgency = () => {
          // location.state might be null, so default to empty object
          const lastTabMap = location.state?.lastTab || {};
          const lastTab = lastTabMap[row.id] || "team_members";

          navigate(`/talent-agencies/${row.id}?type=${lastTab}`, {
            state: {
              prevSearch: location.search,
              lastTab: lastTabMap // pass the existing map along
            }
          });
        };

        return (
          <div className="table-link">
            <a
              rel="noopener noreferrer"
              href=""
              onClick={(e) => {
                e.preventDefault();
                handleViewAgency();
              }}
            >
              View Agency
            </a>
          </div>
        );
      }
    })
  ];
};

export default Columns;
